// @flow
import React, { type Element } from 'react';
import type { ServiceProvider } from '../../../../../../../app/types';
import BusinessCard from './BusinessCard';

export type FlatListProps = {
  onCardClicked: (id: number, proType: string) => void;
  serviceProviders: ServiceProvider[],
};

export const FlatListComponent = (props: FlatListProps): Element<"div"> => {
  const {
    onCardClicked,
    serviceProviders,
  } = props;
  const sps = serviceProviders || [];
  return (
    <div className="business-list">
      {sps.map(sp => (
        <BusinessCard key={sp.id} sp={sp} onCardClicked={onCardClicked} />
      ))}
    </div>
  );
};

export default FlatListComponent;



// WEBPACK FOOTER //
// ./src/modules/home/modules/browser/home/BusinessList/components/FlatList.js